export default function PrintIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clip-path="url(#clip0_12867_259326)">
        <path
          d="M6 7.5V3.75H18V7.5"
          stroke="#4C0F28"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 14.25H6V20.25H18V14.25Z"
          stroke="#4C0F28"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 16.5H2.25V9C2.25 8.17125 2.9775 7.5 3.87469 7.5H20.1253C21.0225 7.5 21.75 8.17125 21.75 9V16.5H18"
          stroke="#4C0F28"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.625 12C18.2463 12 18.75 11.4963 18.75 10.875C18.75 10.2537 18.2463 9.75 17.625 9.75C17.0037 9.75 16.5 10.2537 16.5 10.875C16.5 11.4963 17.0037 12 17.625 12Z"
          fill="#4C0F28"
        />
      </g>
      <defs>
        <clipPath id="clip0_12867_259326">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
